import React from "react";
import "./text.css";

const TextComponent = ({ header, content, image = null }) => {
  return (
    <div className="text-comp-container">
      <h1>{header}</h1>
      <p dangerouslySetInnerHTML={{ __html: content }} />
      {image && <img src={image} alt="Image" />}
    </div>
  );
};

export default TextComponent;
